import * as React from 'react'
import { ReactElement } from 'react'
import { TimeListItemDto } from '../../../../../config/registrationConfig'
import { LineItemProps } from './LineItem'
import { COMMAND_PREFIX } from '../../../../../pages/Commands'
import { timeBaseUrl } from '../../../../../pages/Times'
import { Stack } from '@fluentui/react'
import { Avatar, Badge, Text, Tooltip } from '@fluentui/react-components'
import { CalendarMonthRegular, MoneyRegular, ShiftsRegular } from '@fluentui/react-icons'
import { formatShortDate } from '../../../../../helpers/dateHelper'
import TimeText from '../../../../Text/Time/TimeText'
import MoneyText from '../../../../Text/Currency/MoneyText'
import { Link } from 'react-router-dom'

export default function TimeLineItem({ entity }: LineItemProps<TimeListItemDto>): ReactElement {
    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
            <Tooltip content={entity.user?.fullName} relationship="description" withArrow>
                <Avatar name={entity.user?.fullName} color="colorful" />
            </Tooltip>

            <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
                <Link to={`${COMMAND_PREFIX}${timeBaseUrl}/${entity.id}/edit`}>
                    <Text>{entity.description}</Text>
                </Link>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <Badge size="medium" icon={<CalendarMonthRegular />} appearance="tint">
                        {formatShortDate(entity.date)}
                    </Badge>
                    <Badge size="medium" icon={<ShiftsRegular />} appearance="tint">
                        <TimeText value={entity.duration} />
                    </Badge>
                    <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                        <MoneyText value={entity.rate} textProps={{ size: 200 }} />
                    </Badge>
                </Stack>
            </Stack>
        </Stack>
    )
}
